import { createContext } from 'react';

export const ProductItemContext = createContext({});

export const ProductItemProvider = ({ children, ...props }) => {
  return <ProductItemContext.Provider value={{ ...props }}>{children}</ProductItemContext.Provider>;
};
